const ThankYou = {
  init(mktform = false) {
    let form = mktform
      ? mktform
      : document.querySelector("#marketo-form-area form");

    if (form) {
      //Elements
      this.form = document.querySelectorAll(
        `[name="${form.getAttribute("name")}"`
      );
      this.close = document.querySelectorAll(".js-close-thank-you");

      const thankYouUrl = form.querySelector('[name="thankYou"]')
        ? form.querySelector('[name="thankYou"]').value
        : form.dataset.thankYou;

      if (form && thankYouUrl) {
        const name = form.querySelector('[name="FirstName"]')
          ? form.querySelector('[name="FirstName"]').value
          : false;
        const email = form.querySelector('[name="Email"]')
          ? form.querySelector('[name="Email"]').value
          : false;
        this.redirect(thankYouUrl, name, email);
      } else {
        this.show();
        this.addEvents();
      }
    } else {
      const name = window._name;
      const email = window._email;
      this.redirect(window._form, name, email);
    }
  },

  addEvents() {
    if (this.close.length) {
      this.close.forEach((close) => {
        close.addEventListener("click", () => {
          this.form.forEach((form) => {
            const wrapper = form.nextElementSibling;
            wrapper.classList.add("d-none");
            wrapper.classList.remove("d-flex");
          });
        });
      });
    }
  },

  show() {
    this.form.forEach((form) => {
      const wrapper = form.nextElementSibling;
      if (wrapper) {
        wrapper.classList.remove("d-none");
        wrapper.classList.add("d-flex");
      }
    });
  },

  redirect(url, name, email) {
    window.location =
      url + `${name ? "?n=" + name : ""}` + `${email ? "&email=" + email : ""}`;
  },
};

export default ThankYou;
